module.exports = __webpack_public_path__ + "static/media/body (32).8ed9abb8.jpg";